module.exports = __webpack_public_path__ + "static/media/Slide3.0e812408.jpg";